import React, { useEffect, useState } from 'react'
import styles from './matchCardS.module.css'
import { NavLink } from 'react-router-dom'
import { supabase } from '../../utils/supabaseClient'
import  { Match } from '../../types/matchTypes'

interface MatchCardProps {
	match: Match
}

const MatchCardS: React.FC<MatchCardProps> = ({ match }) => {
	const [homeGoals, setHomeGoals] = useState(0)
	const [awayGoals, setAwayGoals] = useState(0)

	const fetchEvents = async () => {
		try {
			console.log(`Fetching events for match ID: ${match.id}`);
			const { data: periodsData, error: periodsError } = await supabase
				.from('period2match')
				.select('id')
				.eq('fk_match', match.id);

			if (periodsError) {
				throw periodsError;
			}

			const periodIds = periodsData.map((period: any) => period.id);

			const { data: eventsData, error: eventsError } = await supabase
				.from('match_events')
				.select(`
        id,
        fk_period2match,
        fk_event_type,
        fk_persona,
        opt_add_time,
        description,
        time,
        fk_parent,
        match_event_types (
          event_type
        ),
        persona:personas (
          id,
          persona2team (
            fk_team
          )
        )
      `)
				.in('fk_period2match', periodIds);

			if (eventsError) {
				throw eventsError;
			}

			console.log('Events data:', eventsData);

			// Calculate scores
			let homeGoals = 0;
			let awayGoals = 0;

			eventsData.forEach((event: any) => {
				const eventType = event.match_event_types.event_type;
				const personaTeamId = event.persona.persona2team[0]?.fk_team;

				if (eventType === 'goal' || eventType === 'penalty kick') {
					if (personaTeamId === match.fk_team_host) {
						homeGoals++;
					} else if (personaTeamId === match.fk_team_guest) {
						awayGoals++;
					}
				} else if (eventType === 'owngoal') {
					if (personaTeamId === match.fk_team_host) {
						awayGoals++;
					} else if (personaTeamId === match.fk_team_guest) {
						homeGoals++;
					}
				}
			});

			console.log('Home Goals:', homeGoals, 'Away Goals:', awayGoals);
			setHomeGoals(homeGoals);
			setAwayGoals(awayGoals);
		} catch (error) {
			console.error('Error fetching match events:', error);
		}
	};

	useEffect(() => {
		fetchEvents()
	}, [match.id])

	const formatDate = (dateString: string | null) => {
		if (!dateString) return 'N/A'
		const date = new Date(dateString)
		return date.toLocaleDateString('en-US', {
			weekday: 'short',
			month: 'long',
			day: 'numeric'
		})
	}

	const formatTime = (dateString: string | null) => {
		if (!dateString) return 'N/A'
		const date = new Date(dateString)
		return date.toLocaleTimeString('en-US', {
			hour: '2-digit',
			minute: '2-digit',
			timeZoneName: 'short',
		})
	}

	const formattedDate = formatDate(match.actual_start_time)
	const formattedTime = formatTime(match.actual_start_time)

	return (
		<li className={styles.match_card} key={match.id}>
			<p className={styles.match_card__date}>{formattedDate}</p>
			<p className={styles.match_card__time}>{formattedTime}</p>
			<NavLink to={`/matches/${match.id}`}>
			<div className={styles.match_card__scoreboard}>
					{match.host_team_name && match.host_club_logo && (
						<div className={styles.match_card__team}>
							<div className={styles.match_card__home_team_name}>
								<p>{match.host_team_name}</p>
							</div>
							<div className={styles.match_card__team_logo__container}>
								<img
									className={styles.match_card__team_logo}
									src={match.host_club_logo}
									alt={match.host_team_name}
								/>
							</div>
						</div>
					)}
					<div className={styles.match_card__score_container}>
						<div className={styles.match_card__score}>
							<span>{homeGoals ? 0 : ''}</span>
							<span>–</span>
							<span>{awayGoals ? 0 : ''}</span>
						</div>
					</div>
					{match.guest_team_name && match.guest_club_logo && (
						<div className={`${styles.match_card__team} ${styles.match_card__team_away}`}>
							<div className={styles.match_card__team_logo__container}>
								<img
									className={styles.match_card__team_logo}
									src={match.guest_club_logo}
									alt={match.guest_team_name}
								/>
							</div>
							<div className={styles.match_card__team_name}>
								<p>{match.guest_team_name}</p>
							</div>
						</div>
					)}
				</div>
			</NavLink>
			{match.stadium_name && (
				<p className={styles.match_card__stadium}>
					{match.stadium_name}
				</p>
			)}
		</li>
	)
}

export default MatchCardS
